import { ComponentRenderHooks } from "@/plugins/types";
import FacebookLogin, { Properties } from "./component";
import settings from "./settings";
import { ComponentTypes } from "@/Apps/Pages/Editor/types";

export const onListItems = (hook, payload, actions) => {
  if (hook.id === ComponentRenderHooks.WEBCOMPONENT) {
    return [settings];
  }
};

export const onComponentRender = (hook, payload, actions) => {
  if (
    hook.id === ComponentRenderHooks.WEBCOMPONENT &&
    payload.type === ComponentTypes.FACEBOOKLOGIN
  ) {
    return [FacebookLogin];
  }
  
  if (
    hook.id === ComponentRenderHooks.PROPERTIES &&
    hook.type === ComponentTypes.FACEBOOKLOGIN
  ) {
    return Properties(payload);
  }
};
